import {
  HiveStatistics,
  PromotionInfo,
  SummaryLevelCount,
  UserContributionLevelDTO,
  UserContributionLevelPeriodDTO
} from '@/models';
import { axiosBase } from './axios-base';

export const fetchSummaryLevels = (): Promise<{ data: SummaryLevelCount }> => {
  return axiosBase.get('api/contributionLevels/count');
};

export const fetchPromotionInfo = (): Promise<{ data: PromotionInfo }> => {
  return axiosBase.get('api/contributionLevels/promotion');
};

export const fetchContributionLevels = (): Promise<{ data: UserContributionLevelDTO[] }> => {
  return axiosBase.get('api/contributionLevels/summary');
};

export const fetchPeriodsContributionLevels = (): Promise<{ data: UserContributionLevelPeriodDTO[] }> => {
  return axiosBase.get('api/contributionLevels/period');
};

export const fetchHiveStatistics = (): Promise<{ data: HiveStatistics }> => {
  return axiosBase.get('api/contributionLevels/statistics');
};
